export default [{name:'Zlibary',url:'https://zh.z-library.se/s/'},{name:'豆瓣读书',url:'https://search.douban.com/book/subject_search?search_text='},{name:'Liber3',url:'https://liber3.eth.limo/#/search?q='},{name:'懒人听书(有声)',url:'https://www.lrts.me/search/book/'},{name:'喜马拉雅(有声)',url:'https://www.ximalaya.com/so/'},{name:'听东方(有声)',url:'http://www.tingdongfang.com/Search.asp?kw='},{name:'owllook(小说)',url:'https://www.owlook.com.cn/search?wd='},{name:'免费小说网',url:'http://www.12z.cn/plus/search.php?kwtype=0&q='}];


//////////////////
// WEBPACK FOOTER
// ./src/assets/yaml/searchBook.yaml
// module id = null
// module chunks = 